import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/custom",
    name: "custom",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Custom.vue"),
  },
  {
    path: "/label",
    name: "label",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Label.vue"),
  },
  {                   
    path: "/nebula",
    name: "nebula",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Nebula.vue"),
  },
  {
    path: "/talents",
    name: "talents",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Talents.vue"),
  },
  {
    path: "/ai",
    name: "ai",
    component: () => import(/* webpackChunkName: "about" */ "../views/Ai.vue"),
  },
  {
    path: "/partnership",
    name: "partnership",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Partnership.vue"),
  },

  {
    path: "/ecology",
    name: "ecology",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Ecology.vue"),
  },
  {
    path: "/journalism",
    name: "journalism",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/journalism.vue"),
  },
  {
    path: "/detailPage",
    name: "detailPage",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/detailPage.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
